import type { HelpFile } from '../../types/help'
import { ReviewInfoCardTestIds } from '../../../testids/ReviewInfoCardTestIds'

export const reviewInfoCardHelp: HelpFile = {
  docPage: '/docs/governance/restriction-rule-requests',
  texts: {
    [ReviewInfoCardTestIds.reviewInfoCard]:
      'Metadaten der Prüfungsentscheidung — wer entschieden hat, wann und mit welchem Kommentar.',
    [ReviewInfoCardTestIds.cardTitleReviewInfo]: null,
    [ReviewInfoCardTestIds.linkReviewedBy]:
      'Detailseite der prüfenden Identität öffnen.',
    [ReviewInfoCardTestIds.reviewInfoComment]:
      'Kommentar des Prüfers zur Entscheidungsbegründung — bei Ablehnungen immer vorhanden.',
    [ReviewInfoCardTestIds.reviewInfoReviewedAt]:
      'Zeitpunkt der Entscheidung.',
    [ReviewInfoCardTestIds.reviewInfoReviewer]: null,
  },
}
